import { render, staticRenderFns } from "./ProductTemplate.vue?vue&type=template&id=78bf5e2b&scoped=true"
import script from "./ProductTemplate.vue?vue&type=script&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf5e2b",
  null
  
)

export default component.exports